import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DatePickerMDY from "../DatePickerMDY";
import moment from 'moment';
import { DateInputWrapper } from './DateInputMDY.style';


class DateInputMDY extends React.PureComponent {
    static propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        disabled: PropTypes.string,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            focus: false,
            date: props.value ? moment(props.value) : void 0
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            date: props.value ? moment(props.value) : void 0
        });
    }


    setFocus(focus) {
        return () => {
            const { onFocus, onBlur } = this.props;

            if (focus === this.state.focus) {
                return;
            }

            if (focus && onFocus) {
                onFocus();
            } else if (!focus && onBlur) {
                onBlur();
            }

            this.setState({
                focus
            });
        };
    }

    onChange(date) {
        const { onChange } = this.props;

        if (date) {
            date = date.format('YYYY-MM-DD');
        }

        if (onChange) {
            onChange(date);
        }
    }

    render() {
        return (
            <DateInputWrapper className={ classNames(['element', { 'is-focused': this.state.focus } ])}>
               <DatePickerMDY
                    dateFormat="YYYY-MM-DD"
                    disabled={this.props.disabled ? this.props.disabled : false }
                    selected={ this.state.date }
                    {...this.props }
                    onFocus={ this.setFocus(true) }
                    onBlur={ this.setFocus(false) }
                    onChange={ this.onChange.bind(this)}
               />
            </DateInputWrapper>
        );
    }
}

export default DateInputMDY;
